import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { LiquidacaoAntecipadaService } from '../services/liquidacaoantecipada.service';
import { MensagemService } from '../services/mensagem.service';
import { RestClientService } from '../services/restclient.service';
import { Contrato } from '../modelo/contrato';
import { Cliente } from '../modelo/cliente';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BraAlertComponent } from '../componentes/bra-alert/bra-alert.component';
import { MatDialog } from '@angular/material';
import { Config } from '../services/config';

declare var $: any;

@Component({
  selector: 'app-liquidacao-selecao',
  templateUrl: './liquidacao-selecao.component.html',
  styleUrls: ['./liquidacao.component.css'],
  providers: [LiquidacaoAntecipadaService, MensagemService, RestClientService]
})
export class LiquidacaoSelecaoComponent extends AbstractComponent implements OnInit {

  cliente: Cliente = new Cliente();
  indcdContratoCdc: boolean = false;
  indcdContratoLeasing: boolean = false;

  constructor(
    private sessaoService: SessaoService,
    private liquidacaoAntecipadaService: LiquidacaoAntecipadaService,
    private mensagemService: MensagemService,
    private spinnerService: Ng4LoadingSpinnerService,
    private router: Router,
    public dialog: MatDialog) {
    super(sessaoService);
  }

  /**
   * Método chamado na inicialização do componente
   */
  ngOnInit() {
    this.cliente.indcdContratoCdc = false;
    this.cliente.indcdContratoLeasing = false;
    // Menu
    $(".btsMenu .btn").removeClass("active activeDrop");
    $(".liquidacao").addClass("active");
    setTimeout(function () {
      $('ul.tabs').tabs();
    }, 600);

    //Scroll top
    window.scrollTo(0, 0);
    this.buscaTipoContrato();

    // Close Menu Mobile
    var isMobile = window.matchMedia("only screen and (max-width: 760px)");
    $(".content").click(function() {
      if (isMobile.matches) {
        $(".page").removeClass("toggled");
      }
    });
  }

  /**
   * Retorna a lista de tipos de contratos
   */
  buscaTipoContrato = (): void => {
    this.liquidacaoAntecipadaService.recuperarTipoContrato().subscribe(
      (result: Cliente) => {
        this.spinnerService.hide();
        this.cliente = result;
        this.indcdContratoCdc = result.indcdContratoCdc;
        this.indcdContratoLeasing = result.indcdContratoLeasing;
        if (result.cdMsgemRetorno === '00') {
          if (this.cliente.indcdContratoCdc) {
            this.buscaContratosCdc();
          } else if (this.cliente.indcdContratoLeasing) {
            this.buscaContratosLeasing();
          }
        } else if (result.cdMsgemRetorno === '1007') {
          this.sair();
        }
      },
      (error: Response) => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  /**
   * Busca os contratos do Tipo CDC
   */
  buscaContratosCdc = (): void => {
    this.cliente.indcdTipoContrato = '1';
    this.buscaContratos();
  }

  /**
   * Busca os contratos do Tipo Leasing
   */
  buscaContratosLeasing = (): void => {
    this.cliente.indcdTipoContrato = '2';
    this.buscaContratos();
  }

  /**
   * Método que busca os contratos dependendo do tipo
   */
  buscaContratos = (): void => {
    this.liquidacaoAntecipadaService.listarContrato(this.cliente).subscribe(
      (result: Cliente) => {
        if (result.cdMsgemRetorno == "00") {
          this.cliente = result;
          this.sessao.autenticado.nuCpfCnpjFormatado = result.nuCpfCnpjFormatado;
        }
        else {
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: result.dsMsgemRetorno
            }
          });
        }
      },
      (error: Response) => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  /**
   * Exibe os botões de Contrato e Parcela em cada item de contrato exibido na tela
   * @param event
   * @param id
   */
  btnFPA(event, id) {
    $(".boxBts").hide();
    $("#" + event.currentTarget.id + " .boxBts").slideDown(450);
    $(".boxBts").mouseleave(function () {
      $(".boxBts").slideUp(100);
    });
  }

  /**
   * Redireciona para os dados do contrato
   * @param contrato
   */
  confirmarContrato(contrato: Contrato) {
    this.recuperarContrato(contrato, '/BF-Portal/liquidacaoContrato');
  }

  /**
   * Redireciona para os dados da parcela
   * @param contrato
   */
  listarParcela(contrato: Contrato) {
    this.recuperarContrato(contrato, '/BF-Portal/liquidacaoParcelas');
  }

  /**
   * Recupera as informações do contrato selecionado
   */
  recuperarContrato = (contrato: Contrato, route: string): void => {
    this.liquidacaoAntecipadaService.confirmarContrato(contrato).subscribe(
      (result: Contrato) => {
        if (result.cdMsgemRetorno == "0") {
          contrato = result;
          sessionStorage.setItem('liquidacaoContrato', JSON.stringify(contrato));
          this.router.navigate([route]);
        }
        else {
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: result.dsMsgemRetorno
            }
          });
        }
      },
      (error: Response) => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  /**
   * Efetua o logout do sistema e redireciona para o autoline
   */
  sair() {
    sessionStorage.removeItem("sessao");
    sessionStorage.clear();
    this.sessaoService.sessao.logado = false;
    this.router.navigate(['/redirecionamento']);
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-liquidacao-cli/liquidacao-selecao.component.ts